import styled from 'styled-components'


export const Title = styled.span`
   font-size: 24px;
   font-weight: bold; 
   padding-bottom: 3rem;
   color: #252525;
`

export const Subtitle = styled.span`
    font-size: 20px;
    color: #CE1919;
`